const HOT_LIST = [
  { no: 1, title: "收官夜现场画面引热议，观众刷屏求复盘", heat: "98.7万", delta: "+12%", up: true, tag: "综艺" },
  { no: 2, title: "调解节目嘉宾金句破圈，网友：这期含金量拉满", heat: "87.4万", delta: "+9%", up: true, tag: "民生" },
  { no: 3, title: "都市剧尾彩蛋藏伏笔，下一季主线浮出水面", heat: "76.9万", delta: "+7%", up: true, tag: "剧集" },
  { no: 4, title: "餐饮连锁后厨声明遭逐句核实，评论区开课", heat: "63.2万", delta: "-3%", up: false, tag: "商界" },
  { no: 5, title: "音乐节主理人深夜致歉，退票方案成焦点", heat: "51.8万", delta: "-6%", up: false, tag: "现场" },
];

export default function Hero() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 pt-6 md:pt-8 pb-8">
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_360px] gap-5 lg:gap-6">
        {/* 头号大瓜：封面主打，上疏留白 */}
        <article className="group relative overflow-hidden rounded-2xl min-h-[420px] md:min-h-[520px]">
          <img
            src="https://readdy.ai/api/search-image?query=Night%20crowd%20of%20young%20people%20silhouettes%20gathered%20around%20glowing%20smartphones%2C%20warm%20amber%20and%20crimson%20screen%20light%20illuminating%20faces%20from%20below%2C%20urban%20backdrop%20bokeh%2C%20editorial%20news%20magazine%20cover%20photography%2C%20cinematic%20warm%20lighting%2C%20vivid%20orange%20accents%2C%20dramatic%2C%20high%20detail%2C%20no%20text%2C%20no%20watermark&width=1400&height=860&seq=hero-breaking-58&orientation=landscape"
            alt="58黑料吃瓜围观现场人群热议图"
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent"></div>
          <div className="absolute top-4 left-4 flex items-center gap-2">
            <span className="rounded-full bg-accent-500 text-background-50 text-xs font-bold px-3 py-1 flex items-center gap-1">
              <i className="ri-flashlight-fill" aria-hidden="true"></i> 今日头号瓜
            </span>
            <span className="rounded-full bg-background-50/20 backdrop-blur text-background-50 text-xs px-3 py-1">直播 · 综艺</span>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-8">
            <h1 className="font-display font-black text-background-50 text-2xl md:text-4xl leading-snug max-w-2xl">
              镜头外一句话炸出全屏热评，节目组回应后舆论风向再度反转
            </h1>
            <p className="mt-3 md:mt-4 text-background-50/85 text-sm md:text-base max-w-2xl leading-relaxed hidden sm:block">
              从发酵到声量到出圈，短短数小时瓜田便换了三拨风向。围观玩家逐帧复盘、实时评论，评论区已从争吵走向排队补课。
            </p>
            <div className="mt-4 md:mt-6 flex flex-wrap items-center gap-3 md:gap-4">
              <span className="flex items-center gap-2 text-background-50/90 text-xs">
                <i className="ri-time-line" aria-hidden="true"></i> 32 分钟前更新
              </span>
              <span className="flex items-center gap-2 text-background-50/90 text-xs">
                <i className="ri-fire-line" aria-hidden="true"></i> 围观 12.4w
              </span>
              <span className="flex items-center gap-2 text-background-50/90 text-xs">
                <i className="ri-chat-3-line" aria-hidden="true"></i> 评论 3.2w
              </span>
              <span className="ml-auto rounded-full bg-background-50 text-foreground-950 text-sm font-semibold px-4 py-1.5 hidden md:inline-flex items-center gap-1 hover:bg-primary-50 transition-colors cursor-pointer">
                进入热议 <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </article>

        {/* 今日热议榜：榜单醒目，首屏右侧权重 */}
        <aside className="flex flex-col rounded-2xl border border-background-200/70 bg-background-100/60">
          <div className="flex items-center justify-between px-4 md:px-5 pt-4 pb-3">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-bar-chart-2-fill" aria-hidden="true"></i>
              </span>
              <div>
                <h2 className="font-display font-bold text-foreground-950 text-base leading-none">今日热议榜</h2>
                <p className="text-[11px] text-foreground-500 mt-1">瓜田声量 TOP</p>
              </div>
            </div>
            <button type="button" className="text-xs text-primary-600 font-medium hover:underline cursor-pointer">看全部</button>
          </div>
          <div className="flex flex-col px-2 md:px-3 pb-2">
            {HOT_LIST.map((item) => (
              <a
                key={item.no}
                href="#discuss"
                className="group flex items-start gap-3 px-3 py-2.5 rounded-xl hover:bg-background-50 transition-colors cursor-pointer"
              >
                <span
                  className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-sm font-black ${
                    item.no <= 3 ? "bg-accent-500 text-background-50" : "bg-secondary-200 text-secondary-800"
                  }`}
                >
                  {item.no}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">{item.title}</p>
                  <p className="flex items-center gap-3 mt-1.5 text-[11px] text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line" aria-hidden="true"></i> {item.heat}
                    </span>
                    <span
                      className={`flex items-center gap-0.5 font-medium ${
                        item.up ? "text-accent-600" : "text-secondary-600"
                      }`}
                    >
                      <i className={item.up ? "ri-arrow-up-line" : "ri-arrow-down-line"} aria-hidden="true"></i>
                      {item.delta}
                    </span>
                    <span className="ml-auto rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-700">{item.tag}</span>
                  </p>
                </div>
              </a>
            ))}
          </div>
        </aside>
      </div>
    </section>
  );
}